/* Victor Rybakov
 * 16 Apr 2017
 * ColorRowsField is needed for Theme of Gauge widget;
 * it allows to create/delete the color rows <Name-Color> to create user defined color palette;
 * rybak@pdc.spb.su
 */

import * as React from 'react';
import * as _ from 'underscore';

import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';

import StringField from '../../../../_common/platform/tsx/StringField';
import * as Utils from '../../../../_common/application/ts/Utilities';
import { ColorBoxField } from '../../../../_common/platform/tsx/ColorBoxField';

function getState() {
    return {};
}

class ColorRowsField_rows extends React.Component<
    {
        key: string;
        i: number;
        value?: any;
        onChange(value, i);
        onRemove?(i);
        glob?;
    },
    any
> {
    constructor(props) {
        super(props);

        this.state = {};
    }

    private static START_COLOR_DEFAULT = '#ffff00'; // yellow

    processNameChange = (val) => {
        const obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    };

    processNameClick = () => {
        const obj = _.clone(this.props.value || {});
        obj.name = '';
        this.handleValueChange(obj);
    };

    processStartColorChange_ColorBox = (val) => {
        var obj = _.clone(this.props.value || {});
        obj.color = val;
        this.handleValueChange(obj);
    };

    handleValueChange = (value) => {
        if (value.name == null) {
            delete value.color;
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    };

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton = (value) => {
        if (value.name == null) {
            return;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    };

    getName = (value) => {
        let displayVal = value.name || '';

        if (value.name == null) {
            displayVal = (
                <em className="empty" onClick={this.processNameClick}>
                    add
                </em>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="glyphicon glyphicon-cog" onClick={this.processNameClick}></span>
                        <span className="value">{displayVal}</span>
                    </div>
                </div>
            );
        }

        return <StringField onChange={this.processNameChange} value={displayVal} />;
    };

    getRangeBarColor = (value) => {
        if (value.name == null) {
            return;
        }

        const displayVal = value.color || ColorRowsField_rows.START_COLOR_DEFAULT;

        return (
            <ColorBoxField
                value={displayVal}
                hideTransparency={true}
                showText={false}
                onChange={this.processStartColorChange_ColorBox}
                glob={this.props.glob}
            />
        );
    };

    render() {
        const value = this.props.value || {};
        const styleName = { width: '50%' };

        return (
            <tr className="JEST-colorRowsField_rows">
                <td className="cell-remove">{this.getRemoveButton(value)}</td>

                <td className="cell-name" style={styleName}>
                    {this.getName(value)}
                </td>

                <td className="cell-range-bar-color">{this.getRangeBarColor(value)}</td>
            </tr>
        );
    }
}

// VR: 'export' is needed here for JEST testing:
export class ColorRowsField_EditComponent extends React.Component<
    {
        value;
        border: boolean;
        onChange(value);
        glob;
    },
    any
> {
    constructor(props) {
        super(props);

        this.state = _.extend({}, getState.call(this), {});
    }

    private references: {
        getPaletteRow?: HTMLSelectElement;
    } = {};

    private static STYLE1 = { marginBottom: 5, width: '100%' };
    private static DEFAULT_RANGE_SET = [
        { name: '', color: '#ff8080' },
        { name: '', color: '#ffff80' },
        { name: '', color: '#80ff80' },
        { name: '', color: '#0080ff' },
        { name: '', color: '#00ffff' },
        { name: '', color: '#b300b3' }
    ];

    _onChange = () => {
        this.setState(getState.call(this));
    };

    componentWillMount() {
        Utils.devExpressAddCustomPalette();
    }

    handleValueChange = (value) => {
        value.customPaletteArray = _.pluck(value.arr, 'color');

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    addRow = (row) => {
        const obj = _.clone(this.props.value || {});
        if (obj['arr'] == null) obj.arr = [];
        let len = obj.arr.length;
        if (len > 5) len = len % 5;
        row.color = ColorRowsField_EditComponent.DEFAULT_RANGE_SET[len].color;
        obj.arr.push(row);
        this.handleValueChange(obj);
    };

    changeRow = (row, i) => {
        let obj: any = _.clone(this.props.value || {});
        obj.arr.splice(i, 1, row)[0];

        this.handleValueChange(obj);
    };

    removeRow = (i) => {
        const obj = _.clone(this.props.value || {});
        obj.arr.splice(i, 1);
        if (obj.arr.length == 0) {
            return; // VR: DevExpress 18.1 FAILS if the array is empty!!!!!!!!!!!!!
        }
        this.handleValueChange(obj);
    };

    processPaletteChange = () => {
        const val = this.references.getPaletteRow.value;
        const obj = _.clone(this.props.value || {});

        if (val === 'none') {
        } else {
            obj.defaultPaletteName = val;
        }

        this.handleValueChange(obj);
    };

    getPalette(defaultPaletteName) {
        const displayVal = defaultPaletteName ? defaultPaletteName : 'Material';
        const values = [
            'Office',
            'Soft Pastel',
            'Harmony Light',
            'Pastel',
            'Bright',
            'Soft',
            'Ocean',
            'Vintage',
            'Violet',
            'Carmine',
            'Dark Moon',
            'Dark Violet',
            'Green Mist',
            'Soft Blue',
            'Material',
            'Monochrome Blue',
            'Custom (enter below)'
        ];
        const options = _.map(values, function (value) {
            return (
                <option key={value} title={value} value={value}>
                    {value}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.getPaletteRow = input;
                }}
                style={ColorRowsField_EditComponent.STYLE1}
                onChange={this.processPaletteChange}
                value={displayVal}
            >
                {options}
            </select>
        );
    }

    render() {
        let self = this; // needed only for _.map() function!!!
        const arr = this.props.value.arr;

        const rows = _.map(arr, function (obj, i) {
            return (
                <ColorRowsField_rows
                    key={i + '-'}
                    i={i}
                    value={obj}
                    glob={self.props.glob}
                    onChange={self.changeRow}
                    onRemove={self.removeRow}
                />
            );
        });

        const showTableHeaders = rows.length > 0;

        let customPalette;
        if (this.props.value.defaultPaletteName == 'Custom (enter below)') {
            customPalette = (
                <table
                    className={'table' + (this.props.border === true ? ' table-bordered' : '')}
                    style={ColorRowsField_EditComponent.STYLE1}
                >
                    {showTableHeaders === true ? (
                        <thead>
                            <tr>
                                <th className="cell-remove"></th>

                                <th className="cell-name">Name (optional)</th>

                                <th className="cell-range-bar-color">Color</th>
                            </tr>
                        </thead>
                    ) : null}

                    <tbody>
                        {rows}

                        <ColorRowsField_rows key={'00-'} i={-1} glob={self.props.glob} onChange={self.addRow} />
                    </tbody>
                </table>
            );
        }

        return (
            <div className={'JEST-ColorRowsField'}>
                <div className={'div-container'}>
                    <div className="">{self.getPalette(this.props.value.defaultPaletteName)}</div>
                    {customPalette}
                </div>
            </div>
        );
    }
}

export class ColorRowsField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = ColorRowsField_EditComponent;

    public static getDefaultValue() {
        return {
            defaultPaletteName: 'Material',
            customPaletteArray: ['#333399'],
            arr: [
                { name: 'basic', color: '#333399' } //{name: '', color: "#CE2029"}
            ]
        };
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        if (defaultVal == null) {
            defaultVal = ColorRowsField.getDefaultValue();
        }

        super(glob, title, ColorRowsField.defaultValidators, validators, defaultVal, options);
    }
}
